export default "__VITE_ASSET__hUPXK6mA__";